import axios from 'axios';
import router from '@/router';
import store from '@/store';

// Dev API host. Defaults to this machine's loopback; set VUE_APP_API_HOST
// to this machine's own LAN address and port when serving the dev frontend
// to another device, which cannot reach 127.0.0.1 here. Deliberately not
// naming an address: DHCP moves it, and a stale example reads as fact.
const DEV_API_HOST = process.env.VUE_APP_API_HOST || '127.0.0.1:8282';

export const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://aerocle-v1.sheddcapital.com/rest_api' : `http://${DEV_API_HOST}/rest_api`;
export const BASE_AUTH_URL = process.env.NODE_ENV === 'production' ? 'https://aerocle-v1.sheddcapital.com/api' : `http://${DEV_API_HOST}/api`
export const BASE_REST_AUTH_URL = process.env.NODE_ENV === 'production' ? 'https://aerocle-v1.sheddcapital.com/dj-rest-auth' : `http://${DEV_API_HOST}/dj-rest-auth`;


axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if(error.status == 401){
      store.dispatch("auth/logout")
      const route = router.currentRoute.value
      // console.log('route')
      // console.log(route)
      if(route.path.startsWith('/pwa')) {
        router.push('/pwa/auth')
      } else if(route.meta.isRegistrationRoute != true) {
        router.push('/token-expired')
      }
      let controller = new AbortController()
      controller.abort()
    }
    if(error.status == 403){
      router.push('/forbidden-page')
      let controller = new AbortController()
      controller.abort()
    }
    // error.response can be undefined (network error, aborted request,
    // CORS preflight failure, etc.). Guard before dereferencing or this
    // branch throws TypeError and masks the real failure.
    if(error.response && error.response.statusText == "App down for maintenance"){
        alert("App is currently down for maintenance")
        store.dispatch("auth/logout")
        router.push('/maintenance_page')
        // useRouter().push('maintenance-page')
    }
    return Promise.reject(error);
  });

const Client = axios.create({ baseUrl: 'http://127.0.0.1:8282/rest_api/'});

Client.interceptors.request.use(
    (config) => {
    //     const token = localStorage.getItem('token')
    //     if (token) {
    //         config.headers['authorization'] = `Bearer ${token}`
        config.headers['Authorization'] = 'Basic cGF0cmlja19hbHZhcmV6OmZpbG0udGFibGUuY3ljbGU='
        return config
    //    }
    },
    (error) => Promise.reject(error)
)

export default Client